import styled from 'styled-components'

import { IconProps } from '.'
import BaseSvg from './BaseSvg'

const StyledIcon = styled(BaseSvg)`
  width: 20px;
  height: 20px;
`

const PaperPlane = ({ title = 'Paper Plane', ...rest }: IconProps) => (
  <StyledIcon viewBox="0 0 48 48" title={title} {...rest}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.46864 5.19681C5.85542 4.80387 6.4266 4.6548 6.95608 4.80861C20.3533 8.70042 32.7948 14.8363 43.8465 22.7816C44.2385 23.0634 44.4709 23.5167 44.4709 23.9995C44.4709 24.4823 44.2386 24.9356 43.8465 25.2174C32.7949 33.1628 20.3535 39.2989 6.95628 43.1909C6.4268 43.3447 5.85561 43.1956 5.46882 42.8027C5.08203 42.4097 4.942 41.8363 5.10415 41.3093L10.4301 24L5.10397 6.69019C4.94182 6.16321 5.08185 5.58975 5.46864 5.19681ZM13.1073 25.5L8.80082 39.4962C20.159 35.9009 30.7773 30.6399 40.3691 23.9995C30.7772 17.3592 20.1588 12.0984 8.80063 8.50324L13.1073 22.5L27 22.5C27.8285 22.5 28.5 23.1716 28.5 24C28.5 24.8285 27.8285 25.5 27 25.5L13.1073 25.5Z"
      fill="#002AB4"
    />
  </StyledIcon>
)

PaperPlane.displayName = 'PaperPlane'
PaperPlane.needsWork = true
export default PaperPlane
